<template>
    <div class="cookie-alert" v-if="visible">
        <div class="container">
            <p class="mb-0 mr-auto">
                {{ trans('cookie.info', 'Pilnvērtīgai tīmekļa vietnes darbībai mēs izmantojam sīkfailus. Lietojot airBaltic.com, Jūs piekrītat mūsu') }}
                <a :href="trans('cookie.url', 'https://www.airbaltic.com/lv/privatuma-politika')" target="_blank"> {{ trans('cookie.privacy_policy', 'privātuma politikai') }}</a>
            </p>

            <button type="button" class="btn ml-0 mt-4 mt-md-0 ml-md-4" @click="acceptTerms">
                {{ trans('cookie.button', 'Sapratu') }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CookieAlert',

        data() {
            return {
                visible: false
            }
        },

        created() {
            if (!localStorage.getItem('terms-accepted')) {
                this.visible = true
            }
        },

        methods: {
            acceptTerms() {
                $('.cookie-alert').fadeOut(() => {
                    this.visible = false

                    localStorage.setItem('terms-accepted', true)
                })
            }
        }
    }
</script>